/*
 * @Author: your name
 * @Date: 2022-03-28 09:37:06
 * @LastEditTime: 2022-05-06 09:45:51
 * @LastEditors: zhangyigong 947028660@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \xm-cms\src\main.ts
 */
import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
// import { userStore } from "./store";
import { createPinia } from "pinia";
const pinia = createPinia();
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/svgIcon/index";
import "@/style/global.scss";
import BaiduMapVue3 from "baidu-map-vue3";
import svgIcon from "@/svgIcon/index.vue";
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0); // x / y
  document.title = to.meta.title as any;
  next();
});
const app = createApp(App).use(pinia).use(router).use(ElementPlus).component("svg-icon", svgIcon);
app.use(BaiduMapVue3, {
  apiKey: "P2gyvwMB9rumkGBrddDOZ9SLGopxq1jw"
});
app.mount("#app");
